import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendResetPasswordEmail } from "../auth/authService";
import "../styles/SignUp.css";
import "../styles/SetPassword.css";
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError("Email is required.");
      return;
    }
  
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError("Invalid email format.");
      return;
    }
  
    setSending(true);
    try {
      await sendResetPasswordEmail(email);
      navigate("/check-inbox", { state: { email } }); // This still works!
    } catch (err) {
      alert("Failed to send reset link: " + err.message);
    } finally {
      setSending(false);
    }
  };
  
  

  return (
    <div className="setpassword-container">
      {/* Left Panel (Same as SetPassword) */}
      <div className="setpassword-left">
        <img src="/log-img.png" alt="Reset Illustration" className="signup-image" />
        <img src="/star-icon.svg" alt="Star" className="star-icon star-icon-top" />
        <img src="/blue-star-icon.svg" alt="Blue Star" className="star-icon star-icon-bottom" />
        <div className="white-circle"></div>
        <div className="setpassword-badge track">
          <img src="/track-icon.svg" alt="Track Icon" />
          <p>Track & Manage <br />document on the go!</p>
        </div>
        <div className="white-circle-bottom"></div>
        <div className="white-circle-bottom-right"></div> 
        <div className="white-circle-bottom-right-up"></div> 
        <div className="setpassword-badge speed">
          <img src="/speed-icon.svg" alt="Speed Icon" />
          <p>Gain speed with <br/>your document delivery 🚀</p>
        </div>
        <div className="setpassword-badge dispatch">
          <img src="/dispatch-icon.svg" alt="Dispatch Icon" />
          <p>Dispatch your Cheques <br />from anywhere</p>
        </div>
      </div>

      {/* Right Panel - Reset Email */}
      <div className="setpassword-right">
        <div className="setpassword-wrapper">
          <div className="setpassword-card">
            <h2 className="setpassword-title">Forgot Your Password?</h2>
            <p className="setpassword-subtext">
              Enter your email address and we'll send you a reset link.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="set-input-group">
                <img src="/mail-icon.svg" alt="Email Icon" className="input-icon" />
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError("");
                  }}
                  required
                />
              </div>

              {error && <p className="setpassword-error">{error}</p>}

              <button className="setpassword-button" type="submit" disabled={sending}>
                {sending ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            <p className="setpassword-subtext link-text">
              Know your password?{" "}
              <span className="login-link" onClick={() => navigate("/login")}>Go to login</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
